var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.href === "" ? "div" : "a",
    {
      directives: [
        {
          name: "touch",
          rawName: "v-touch:tap",
          value: () => _vm.$audio.play("/sounds/click.mp3"),
          expression: "() => $audio.play('/sounds/click.mp3')",
          arg: "tap",
        },
      ],
      tag: "component",
      staticClass: "v-option",
      class: {
        "v-option--selected": _vm.selected,
        "v-option--no-text": _vm.noText,
        "v-option--full-image": _vm.fullImage,
      },
      attrs: { href: _vm.href, target: "_blank" },
    },
    [
      _c("div", {
        staticClass: "v-option__image",
        style: { backgroundImage: `url('${_vm.image}')` },
      }),
      !_vm.noText
        ? _c(
            "span",
            {
              staticClass: "v-option__text",
              class: { "v-option__text--jp": _vm.isJapanese },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }